<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
            <div></div>
			<div>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiProductFacilitatorCategoryQueryList">刷新</a-button>
			</div>
		</div>

		
		<div class="qinang-card">
			<div >
				<a-breadcrumb >
                    <a-breadcrumb-item>
                        <a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
                            <a-form-model-item  label="绑定产品分类" has-feedback  >
                                <a-select style="width: 80%;" mode="multiple" v-model="addForm.productCategoryIds" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择产品分类">
                                    <a-select-option v-for="(item,index) in bindCategoryList" :value="item.productCategoryId" :key="index" :disabled="item.disabled">{{item.name}}</a-select-option>
                                </a-select>
                                <a-button style="margin-left: 10px;" type="primary" @click="apiProductFacilitatorCategoryAdd" :loading="addConfirmLoading">绑定</a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </a-breadcrumb-item>
                </a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="id" :loading="tableLoading" :pagination="false">

			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
        props:{
			facilitatorId:{
				type:Number,
				default:""
			}
		},
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//产品分类列表
				productCategoryList: [],
				//已绑定服务商列表
				bindList:[],
				//绑定产品分类列表
				bindCategoryList:[],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: undefined,
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
                    // { title:'ID', dataIndex:'id', key:'id', align:'center'},
					{ title:'分类名称',dataIndex:'productCategoryName', key:'productCategoryName', align:'center'},
					
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					productCategoryId: undefined,
					facilitatorId: undefined,
					productCategoryIds: [],
                    // enterpriseId: undefined,
				},
				addRules: {
					
				},
				// 添加弹窗-end

			};
		},
		methods: {
            //获取分类列表
			async apiProductCateList() {
				let query = this.query
				query.facilitatorId = this.facilitatorId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductCateList,this.query);
				if (res.code == 200) {
					this.productCategoryList = res.data
					this.facilitator2bindCategoryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			facilitator2bindCategoryList(){
				let bindCategoryList = []
				for(let i = 0; i < this.productCategoryList.length; i++){
					bindCategoryList.push({
						productCategoryId:this.productCategoryList[i].productCategoryId,
						name:this.productCategoryList[i].name,
						disabled:this.bindList.find(item=>item.productCategoryId==this.productCategoryList[i].productCategoryId)== null?false:true
					})
				}
				this.bindCategoryList = bindCategoryList
			},

			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			//获取已绑定分类列表
			async apiProductFacilitatorCategoryList(){
				const {
					data:res
				} = await this.$http.post(this.navigation.apiProductFacilitatorCategoryList,{facilitatorId:this.facilitatorId})
				if(res.code == 200){
					this.bindList = res.data
				}
			},

			//--------------表格开始-搜索
			async apiProductFacilitatorCategoryQueryList() {
				
				this.tableLoading = true
                let query = this.query
                query.facilitatorId = this.facilitatorId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductFacilitatorCategoryQueryList, query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiProductFacilitatorCategoryQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiProductFacilitatorCategoryQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			async apiProductFacilitatorCategoryAdd() {
				if(this.addForm.productCategoryIds.length == 0){
					this.$message.error("请选择产品分类")
					return false
				}
				this.addConfirmLoading = true
				this.addForm.facilitatorId = this.facilitatorId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductFacilitatorCategoryAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.addForm ={}
					this.resetBindList()
					this.apiProductFacilitatorCategoryQueryList()
				} else {
					this.$message.error(res.msg)
				}
				this.addConfirmLoading = false
			},


			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.id)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiProductFacilitatorCategoryDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiProductFacilitatorCategoryDel(ids) {
				console.log(ids)
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductFacilitatorCategoryDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.resetBindList()
					this.apiProductFacilitatorCategoryQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			resetBindList(){
				this.apiProductFacilitatorCategoryList().then(()=>{
					this.facilitator2bindCategoryList()
				})
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
			this.apiProductFacilitatorCategoryList().then(() => {
				this.apiProductCateList()
				this.apiProductFacilitatorCategoryQueryList()
			})
		}
	};
</script>

<style scoped>
	.qinang-card ::v-deep .ant-form-item{
		margin-bottom: 0;
	}
</style>
